// extracted by mini-css-extract-plugin
module.exports = {"header":"_2HA0lr","header__title":"_3RH4cx","header__subtitle":"_2bpr21","header__close":"_3XD-rT"};